export default {
  getCompanieBranches(state) {
    if (state.allBranches) return state.allBranches
    return null
  },
}
